export type GoogleAdsConversionKey = 'barendrecht' | 'rhoon' | 'rotterdam_centrum' | 'rotterdam_kralingen_crooswijk';

const locationSlugToConversionKey: Record<string, GoogleAdsConversionKey> = {
    'rotterdam-centrum': 'rotterdam_centrum',
    'rotterdam-crooswijk': 'rotterdam_kralingen_crooswijk',
    'rotterdam-kralingen-crooswijk': 'rotterdam_kralingen_crooswijk',
    'rhoon-portland': 'rhoon',
    'barendrecht-carnisselande': 'barendrecht',
    'barendrecht-oranjewijk': 'barendrecht'
};

export function getConversionKeyForLocation(slug: string): GoogleAdsConversionKey | null {
    const normalizedSlug = slug.trim().toLowerCase();

    return locationSlugToConversionKey[normalizedSlug] ?? null;
}
